// frontend/klaes-app/src/components/FilmFavs/components/FilmEntry.jsx
import { useState } from 'react';
import { FiEdit2, FiTrash2, FiStar } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { RatingPopup } from './RatingPopup';
import styles from '../FilmFavs.module.css';

export const FilmEntry = ({
  entry,
  currentUser,
  onEdit,
  onDelete,
  onUserRating,
  onShowRatings,
  typeLabels = { film: 'Film', series: 'Serie' },
  artistLabel,
  personField = 'artist'
}) => {
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const userRating = entry.user_ratings?.[currentUser];
  const hasUserRating = userRating !== undefined;

  return (
    <div className={styles.filmEntry}>
      <div className={styles.entryHeader}>
        <div className={styles.entryType}>{typeLabels[entry.type]}</div>
        <div className={styles.entryActions}>
          <button onClick={() => onEdit(entry)}><FiEdit2 /></button>
          <button onClick={() => onDelete(entry.id)}><FiTrash2 /></button>
        </div>
      </div>

      <h3 className={styles.entryName}>{entry.name}</h3>
      {artistLabel && entry[personField] && <p className={styles.entryDescription}>{artistLabel}: {entry[personField]}</p>}
      <p className={styles.entryDescription}>{entry.description}</p>

      <div className={styles.chipContainer}>
        {entry.tags?.map((tag, i) => (
          <Chip key={i} label={tag.name} category={tag.category} />
        ))}
      </div>

      <div className={styles.ratingSection}>
        <div className={styles.averageRating}>
          <span className={styles.ratingLabel}>Ø Bewertung</span>
          <BatteryIndicator rating={entry.current_ranking} onClick={onShowRatings} />
        </div>

        <div className={styles.userRating}>
          <span className={styles.ratingLabel}>Deine Bewertung</span>
          {hasUserRating ? (
            <BatteryIndicator 
              rating={userRating} 
              isUserRating 
              onClick={() => setShowRatingPopup(true)}
            />
          ) : (
            <button 
              className={`${styles.rateButton} ${styles.pulsate}`}
              onClick={() => setShowRatingPopup(true)}
            >
              <FiStar /> Bewerten
            </button>
          )}
        </div>
      </div>

      {showRatingPopup && (
        <RatingPopup 
          onRate={(rating) => onUserRating(entry.id, rating, setShowRatingPopup)}
          onClose={() => setShowRatingPopup(false)}
          currentRating={userRating}
        />
      )}
    </div>
  );
};